// @flow
import * as React from "react"
import { compose, withHandlers, type HOC } from "recompose"
import withConnect from "hoc/withConnect"
import { Text } from "componentsStyled/Typography/Texts"
import ArrowIcon from "assets/icons/ArrowIcon"
import ApplyPromoCode from "modals/ApplyPromoCode"
import { openModal } from "data/modals/actions"
import type { ReservationPricingQueryInput } from "data/reservations/graphql/queries"
import type { OriginalReservation } from "data/reservations/types"
import { PromoCodeLinkWrapper } from "./styled"

const PromoCodeLink = ({ handleClick, originalReservation }) => {
  if (originalReservation) {
    return null
  }

  return (
    <PromoCodeLinkWrapper onClick={handleClick}>
      <Text black book lh={6}>
        Have a promo code?
      </Text>
      <ArrowIcon rotation="right" />
    </PromoCodeLinkWrapper>
  )
}

type Outter = {|
  input: ReservationPricingQueryInput,
  originalReservation: ?OriginalReservation,
|}

const enhancer: HOC<*, Outter> = compose(
  withConnect(() => ({}), { openModal }),
  withHandlers({
    handleClick: props => () =>
      props.openModal(ApplyPromoCode, {
        input: props.input,
      }),
  }),
)

export default enhancer(PromoCodeLink)



// WEBPACK FOOTER //
// ./src/pages/Checkout/CheckoutForm/PromoCodeLink/index.js